module.exports = __webpack_public_path__ + "img/assessment__rating__star.073d11e0.svg";